// extracted by mini-css-extract-plugin
module.exports = {"embed":"iframe-embed_embed__a7SHv","embed__container":"iframe-embed_embed__container__U8fie","embed--loaded":"iframe-embed_embed--loaded__23fxH"};